/**
 * @file index.tsx
 *
 * @fileoverview Renders button which use mobile phones native sharing functionality.
 */

import { SharingButtonProps } from '~/jobiqo/components/SocialMedia/SharingButtons/components/Custom';
import { Button } from '~/vcl/atoms/01-forms/01-button';
import { FormattedMessage, useIntl } from 'react-intl';
import ShareIcon from '~/vcl/icons/Share';
import { useFlags } from '~/jobiqo/hooks/flags';
import {
  analyticsDispatch,
  DIMENSIONS,
  EVENTS,
  setEventParams,
} from '~/jobiqo/lib/analytics';
import { getJobDimensions } from '~/jobiqo/components/Job/utils/job_analytics';

export const SharingButtonNative = ({
  url,
  title,
  sharingEntity,
  sharingEntityType,
}: SharingButtonProps) => {
  const flagService = useFlags();
  const intl = useIntl();
  const handleShare = async () => {
    if (navigator?.share) {
      try {
        if (url && sharingEntity && sharingEntityType) {
          const shareMethod = setEventParams({
            [DIMENSIONS.share_method]: 'native',
          });
          switch (sharingEntityType) {
            case 'job':
              const jobDimensions = getJobDimensions(sharingEntity);
              analyticsDispatch(EVENTS.JOB_SHARE, {
                ...jobDimensions,
                ...shareMethod,
              });
              break;
            default:
              break;
          }
        }
        await navigator.share({ title: title, url: url });
      } catch (err: any) {
        if (err.name !== 'AbortError') {
          flagService.addFlag({
            type: 'danger',
            text: intl.formatMessage({
              id: 'social_media_sharing_error',
              defaultMessage: 'Error occurred whilst sharing',
            }),
          });
        }
      }
    } else {
      flagService.addFlag({
        type: 'danger',
        text: intl.formatMessage({
          id: 'social_media_sharing_not_supported',
          defaultMessage: 'Sharing is not supported on this device',
        }),
      });
    }
  };

  return (
    <Button buttonStyle="primary" onClick={handleShare}>
      <ShareIcon
        title={
          <FormattedMessage
            id="social_media_sharing_buttons_icon_text"
            defaultMessage="Share"
          />
        }
      />
      <span>
        <FormattedMessage
          id="social_media_sharing_buttons_label"
          defaultMessage="Share"
        />
      </span>
    </Button>
  );
};

export default SharingButtonNative;
